import React/* , { useContext } */ from 'react';
import PokemonImg from '../pokemonImg/pokemonImg';
//import BtnRounded from '../btn/btnRounded';
import { getUserFromLocalStorage } from '../../utils/localStorage';
//import { Link } from 'react-router-dom';
//import { AppConfigContext } from '../../Config/App';
//import { LanguageContext } from '../../Data/Context/languageContext';
//import { logOut } from '../../features/user/userSlice';
//import InputText from '../forms/inputText';

const DashBoardSideBar = (props) => {
    const user_session = getUserFromLocalStorage();
    //const { navigate_to } = useContext(AppConfigContext);
    //const { t } = useContext(LanguageContext);

    /* const logout_user = () => {
        logOut(t("toast_logged_out"));
        navigate_to();
    } */

    return (
        <div className={`col rounded`} id="dashboar-sidebar">
            <div className="row">

                <div className="py-3 text-center">
                    <div className="d-flex flex-column justify-content-center align-items-center">
                        <PokemonImg borderType="blue-border" src={'https://pokeland-legends.club/public/assets/img/personalities/original-size/hasty.webp'} animated={true} />
                        <p className="col mt-3">{user_session.username}</p>

                        <div className="accordion accordion-flush col-12" id="dashboardAccordion">
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="flush-headingOne">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                        Account Settings
                                    </button>
                                </h2>
                                <div id="flush-collapseOne" className="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#dashboardAccordion">
                                    <div className="list-group">
                                    <div className='list-group-item'>
                                        Coming Soon!
                                    </div>
                                        {/* <div className='list-group-item'>
                                            <InputText
                                                isForm={true}
                                                //handleChange={handleChange}
                                                placeholder="Email"
                                                name="email"
                                                value="wilson-gomesr@hotmail.com">
                                                Email
                                            </InputText>
                                        </div>

                                        <div className='list-group-item'>
                                            <Link onClick={logout_user} to={navigate_to()}>
                                                <BtnRounded classes="btn-success">{t("save_changes")}</BtnRounded>
                                            </Link>
                                        </div> */}
                                    </div>
                                </div>
                            </div>
                            {/* <div className="accordion-item">
                                <h2 className="accordion-header" id="flush-headingTwo">
                                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                        Manage Builds
                                    </button>
                                </h2>
                                <div id="flush-collapseTwo" classname="accordion-collapse collapse" aria-labelledby="flush-headingTwo" data-bs-parent="#dashboardAccordion">
                                    <div className="list-group">
                                        <li classname="list-group-item">My builds</li>
                                        <li classname="list-group-item">Create new</li>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}
export default DashBoardSideBar;